import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowConstructionReview", inputValue, ShowServiceResultSuccess);
	}, []);

	const ShowServiceResultSuccess = (ServiceResult) => {

		for (let i = 0; i < ServiceResult.FileChargesInfoList.length; i++) {
			let item = ServiceResult.FileChargesInfoList[i];

			item.CalculatedAmount = item.CalculatedAmount.toLocaleString();
			item.DeclaredAmount = item.DeclaredAmount.toLocaleString();
			item.ReceivedAmount = item.ReceivedAmount.toLocaleString();
		}

		setServiceResult(ServiceResult);
	}

	return (
		<div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')} />
			<ShowFilesReviewAbstractList />
			{getServiceResult ? <div>
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">سطح بنای موجود:</b> {getServiceResult.ExistingBuildingArea} </td>
							<td><b class="b1">تعداد واحد مسکونی:</b> {getServiceResult.ResidentialUnitCount} </td>
							<td><b class="b1">قیمت منطقه ای:</b> {getServiceResult.RegionalPrice && getServiceResult.RegionalPrice.toLocaleString()} </td>
						</tr>
						<tr>
							<td><b class="b1">تعداد مالکین:</b> {getServiceResult.OwnersCount} </td>
							<td><b class="b1">پروانه قبلی:</b> {getServiceResult.IsPreviousConstruction ? 'دارد' : 'ندارد'} </td>
							<td><b class="b1">پروانه قبلی تخریب و نوسازی  یا پروانه:</b> {getServiceResult.IsPreviousConstructionRebuild ? 'بله' : 'خیر'} </td>
						</tr>
						<tr>
							<td><b class="b1">تعداد واحد قبلی:</b> {getServiceResult.PreviousUnitCount} </td>
							<td><b class="b1">بنای ناخالص قبلی:</b> {getServiceResult.PreviousBuildingArea} </td>
							<td><b class="b1">مقدار پرداختی قبل:</b> {getServiceResult.PreviousChargesPaid && getServiceResult.PreviousChargesPaid.toLocaleString()} </td>
						</tr>
						<tr>
							<td><b class="b1">احداث بنا بعد از 69/1/16:</b> {getServiceResult.IsBuildingAfterBaseDate ? 'بوده' : 'نبوده'} </td>
							<td><b class="b1">قیمت تغییر منطقه:</b> {getServiceResult.IsRegionalPriceChanged ? 'بله' : 'خیر'} </td>
							<td><b class="b1">مبلغ کسورات:</b> {getServiceResult.DeductionsAmount && getServiceResult.DeductionsAmount.toLocaleString()} </td>
						</tr>
					</tbody>
				</table>
				<br />
				<GridControl
					data={Object.keys(getServiceResult).length > 0 && getServiceResult.FileChargesInfoList}
					customHeaders={{
						"ChargesTitle": "عنوان عوارض",
						"CalculatedAmount": "مبلغ محاسبه شده",
						"DeclaredAmount": "مبلغ اعلام شده",
						"ReceivedAmount": "مبلغ وصول شده",
						"Formula": "فرمول خام",
						"NumberedFormula": "فرمول عدد گذاری شده"
					}}
					customRenderCell={{
						Formula: (row) => (
							<div dir="ltr" style={{ textAlign: "center" }}>
								{row.Formula}
							</div>
						),
						NumberedFormula: (row) => (
							<div dir="ltr" style={{ textAlign: "center" }}>
								{row.NumberedFormula}
							</div>
						)
					}}
				/>
				<br />
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">جمع محاسبه شده:</b> {getServiceResult.TotalCalculatedAmount && getServiceResult.TotalCalculatedAmount.toLocaleString()} </td>
							<td><b class="b1">جمع اعلام شده:</b> {getServiceResult.TotalDeclaredAmount && getServiceResult.TotalDeclaredAmount.toLocaleString()} </td>
							<td><b class="b1">جمع وصول شده:</b> {getServiceResult.TotalReceivedAmount && getServiceResult.TotalReceivedAmount.toLocaleString()} </td>
						</tr>
					</tbody>
				</table>
				<br />
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">مطابق ضوابط شهرداری:</b> {getServiceResult.IsRegulationsMunicipalAccording ? 'می باشد' : 'نمی باشد'}</td>
							<td><b class="b1">مطابق سوابق کسبی:</b> {getServiceResult.IsTradeHistory ? 'می باشد' : 'نمی باشد'}</td>
							<td><b class="b1">ملک در محدوده بازار:</b> {getServiceResult.IsOnBazaarPlace ? 'می باشد' : 'نمی باشد'}</td>
						</tr>
						<tr>
							<td><b class="b1">از محوطه اخذ عوارض:</b> {getServiceResult.IsGetChargesArea ? 'شده' : 'نشده'}</td>
							<td><b class="b1">مشمول 50درصد تخفیف شهرداری:</b> {getServiceResult.IsIncludingDiscount ? 'می باشد' : 'نمی باشد'}</td>
							<td><b class="b1">تخفیف شهرداری:</b> {getServiceResult.MunicipalDiscount}</td>
						</tr>
					</tbody>
				</table>
				<br />
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">عنوان فیلد اول:</b> {getServiceResult.FirstField}</td>
							<td><b class="b1">عنوان فیلد دوم:</b> {getServiceResult.SecondField}</td>
							<td><b class="b1">قیمت کارشناسی:</b> {getServiceResult.ExpertPrice}</td>
						</tr>
						<tr>
							<td><b class="b1">توضیحات اعلام عوارض:</b> {getServiceResult.DeclarationDescription}</td>
							<td><b class="b1">توضیحات وصول عوارض:</b> {getServiceResult.ReceiveDescription}</td>
						</tr>
					</tbody>
				</table>
			</div>
				:
				<div className="alert alert-danger text-center">موردی یافت نشد.</div>
			}
		</div>
	);
}
